import { loader } from 'graphql.macro'

export default async function activateUser ({ dataLoaders, variables }) {
  const schema = loader('./activateUser.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      userId: variables.userId,
      status: variables.status
    }
  })
  return response.activateUser
}
